import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { RoutePath } from '@common/enums';
import { AuthService } from '@common/services/auth/auth.service';
import { ModalService, ModalSettings } from 'mbs-ui-kit';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

const sessionExpiredTemplate = `
<div class="row flex-nowrap align-items-center">
  <div class="col-auto">
    <div class="modal_content-ico text-primary bg-primary -circle">
      <span class="fa fa-info text-white"></span>
    </div>
  </div>
  <div class="mbs-modal_content-text col-10">
    Your session has expired. Please log in again.
  </div>
</div>`;

const handleSessionExpired = async (authService: AuthService, modalService: ModalService): Promise<void> => {
  authService.logout(
    new HttpErrorResponse({
      status: 440,
      error: { message: 'Your session has expired. Please log in again' }
    })
  );

  const settings: ModalSettings = {
    header: { title: 'Session Expired' },
    footer: {
      okButton: { text: 'Login' },
      cancelButton: { show: false }
    }
  };

  try {
    await modalService.open(settings, sessionExpiredTemplate);
  } finally {
    isModalOpen = false;
  }
};

const excludePaths = [`/${RoutePath.Login}`, `/${RoutePath.AuthCallback}`, `/${RoutePath.Account}`, `/${RoutePath.NotFound}`];
let isModalOpen = false;

export const sessionInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const modalService = inject(ModalService);
  const router = inject(Router);

  const currentPath = router.url.split(/[?#]/)[0];

  if (excludePaths.some((path) => currentPath.endsWith(path))) {
    return next(req);
  }

  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && error.status === 401 && !isModalOpen) {
        isModalOpen = true;

        void handleSessionExpired(authService, modalService);
      }

      return throwError(() => error);
    })
  );
};
